// extracted by css-extract-rspack-plugin
export default {"cls1":"ActiveState-cls1_pZu","cls2":"ActiveState-cls2_qF9 ActiveState-cls1_pZu"};